// extracted by mini-css-extract-plugin
export default {"links":"Links_links__DV-Li","col":"Links_col__bT4zt","inputDiv":"Links_inputDiv__yiXig"};